import cn from 'classnames';
import React, { FC, memo, useMemo } from 'react';

import {
  CHAINS_FILTER,
  CHAIN_ID,
  CHAIN_INFO,
} from '@constants/common/chain.constants';

import useStyles from './styles.module';

interface Props {
  selectedChains: CHAIN_ID[];
  onChangeChain: (chain: CHAIN_ID) => void;
  className?: string;
}

const areAllChainsSelected = (chains: number[], selectedChains: number[]) =>
  chains.every((chain) => selectedChains.includes(chain));

const FilterChains: FC<Props> = ({
  className,
  onChangeChain,
  selectedChains,
}) => {
  const { classes } = useStyles();

  const isSelectedAllChains = useMemo(
    () => areAllChainsSelected(CHAINS_FILTER, selectedChains),
    [selectedChains],
  );

  return (
    <div className={cn(classes.chains, className)}>
      {CHAINS_FILTER.map((chainId) => {
        const isActive =
          selectedChains.includes(chainId) || isSelectedAllChains;

        return (
          <button
            key={chainId}
            className={cn(classes.chain, { [classes.selectedChain]: isActive })}
            onClick={() => onChangeChain(chainId)}
          >
            {isActive ? (
              <img src={CHAIN_INFO[chainId].logo} alt="" />
            ) : (
              <img src={CHAIN_INFO[chainId].inactiveLogo} alt="" />
            )}
          </button>
        );
      })}
    </div>
  );
};

export default memo(FilterChains);
